module.exports = __webpack_public_path__ + "static/media/LOGO_HOME_SCO_ESP.38c3d216.svg";